import jQuery from 'jquery';
import ValidateEmail from "./emailValidator";

export default () => {
    jQuery(document).ready(function ($) {

        const url = '/blog/wp-admin/admin-ajax.php';

        const CONTACTS_LIST = atob('NWYxNTdmNmI4OTBlZGVhNzM5NTVhODc4');

        const  mailerUrl = atob('L3NlbmRlci9jb250YWN0cy9hZGQ=');

        $('body').on('click', '.ratting-btn', function () {
            let ratting = $(this).attr('data-rate');
            let postid = $(this).closest('ul').attr("data-post-id");

            $.ajax({
                type: "post",
                url: url,
                data: `action=ratting&nonce=ajax-nonce&ratting=${ratting}&postid=${postid}`,
                success: function (count) {
                    let voteBlock = $('.vote-p');
                    if (count.result === "already") {
                        voteBlock.html('You already voted on this poll!')
                    }

                    if (count.result === "success") {
                        $('.post-average-ratting').html(count.ratting);
                        voteBlock.html('Thank you for your vote!')
                    }
                    $('.ratting-list').addClass('voted');
                }
            });
            return false;
        })

        $('body').on('click', '.subscribe button', function () {
            let block = $(this).closest('div');
            let email = block.find('input[type="email"]')
            let emailVal = email.val();
            let button = $(this);
            if(!ValidateEmail(emailVal)) {
                email.addClass('error');
                return false;
            }

            const locale = document.querySelector('html').getAttribute('lang')

            $.ajax({
                type: "post",
                url: url,
                data: `action=contactus&locale=${locale}&domain=${window.location.hostname}&email=${emailVal}`,
                success: function (createContact) {

                    if (createContact.result === true) {
                        $('.subscribe').addClass('success');
                        email.val('Thank you for subscribe!');
                        email.attr('disabled','disabled');
                        button.attr('disabled','disabled');
                        document.cookie = 'mail_sub_act=true;max-age=7200';
                    }
                }
            });
            return false;
        })
        $('body').on('change paste keyup', 'input[type="email"]', function () {
            let emailVal = $(this).val();
            if(ValidateEmail(emailVal)) {
                $(this).removeClass('error');
            }
        })
    });
}
